import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FieldBase } from '../shared/field-base';
import { FieldErrorComponent } from '../shared/field-error.component';

@Component({
  selector: 'ds-text-area',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FieldErrorComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
  template: `
    <div class="ds-field">
      <label class="ds-field__label" [for]="fieldId">
        {{ label() }}
        @if (required()) {
          <span class="ds-field__required" aria-hidden="true">*</span>
        }
      </label>
      @if (helperText()) {
        <p class="ds-field__helper" [id]="fieldId + '-helper'">{{ helperText() }}</p>
      }
      <textarea
        class="ds-input ds-textarea"
        [id]="fieldId"
        [value]="value() ?? ''"
        [disabled]="disabled()"
        [required]="required()"
        [rows]="rows()"
        [placeholder]="placeholder() ?? ''"
        [attr.maxlength]="maxLength() ?? null"
        [attr.aria-invalid]="errorText() ? 'true' : null"
        [attr.aria-describedby]="describedBy()"
        (input)="handleInput($event)"
        (blur)="onTouched()"
      ></textarea>
      @if (errorText()) {
        <ds-field-error [errorId]="fieldId + '-error'">{{ errorText() }}</ds-field-error>
      }
    </div>
  `,
  styles: `
    .ds-textarea {
      resize: vertical;
      min-height: 120px;
      line-height: var(--leading-body);
    }
  `,
})
export class TextAreaComponent extends FieldBase<string> {
  rows = input(4);
  placeholder = input<string | undefined>(undefined);
  maxLength = input<number | undefined>(undefined);

  protected handleInput(event: Event): void {
    const next = (event.target as HTMLTextAreaElement).value;
    this.value.set(next);
    this.onChange(next);
  }
}
